export const UNABLE_TO_CALCULATE = 'UNABLE_TO_CALCULATE';
export const NO_SAFE_VERSION = 'NO_SAFE_VERSION';

export const hasFix = (fix: string) => fix !== NO_SAFE_VERSION && fix !== UNABLE_TO_CALCULATE;
